export default function GooglePayPreview({src}) {
    return (
        <div
            className={`gpay-block-editor`}
            style={{maxHeight: '40px', backgroundColor: '#000', borderRadius: '4px'}}>
            <img
                src={src}
                style={{
                    width: '100%',
                    height: '40px',
                    objectFit: 'contain'
                }}/>
        </div>
    )
}